import { render, staticRenderFns } from "./CompanyTransactionCard.vue?vue&type=template&id=f688bc98"
import script from "./CompanyTransactionCard.vue?vue&type=script&lang=js"
export * from "./CompanyTransactionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports